import { Injectable } from '@angular/core';
import { ClientLocalization, UpdateLocalizationListRequest } from '@ats/api/cm';
import { CmInterceptHeaders } from '@ats/cm/core';
import { gql, Mutation } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { ENTRY_EXISTS_GUID } from '../models/ignored-error-guids';

@Injectable({
	providedIn: 'root',
})
export class ClientLocalizationUpdateGql extends Mutation<
	{ updateClientLocalizationList: ClientLocalization[] },
	{ request: UpdateLocalizationListRequest }
> {
	document = gql`
		mutation updateClientLocalizationList($request: UpdateLocalizationListRequest!) {
			updateClientLocalizationList(request: $request) {
				name
				locType
				value
				englishValueResolved
				cultureInfoName
			}
		}
	`;

	update$(request: UpdateLocalizationListRequest): Observable<string[]> {
		return this.mutate(
			{ request },
			{ context: { headers: CmInterceptHeaders.SuppressErrorById(ENTRY_EXISTS_GUID) } }
		).pipe(
			map(({ data }) => data?.updateClientLocalizationList || []),
			map(locs => locs.map(loc => loc.name))
		);
	}
}
